module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1156.38d17123.png";